export default __webpack_public_path__ + "static/media/vue.7bc2f1c7.svg";